import img1 from '../../assets/img/team-4.jpg';
import img2 from '../../assets/img/team-6.jpg';
import img3 from '../../assets/img/team-5.jpg';
import img4 from '../../assets/img/team-1.jpg';
import img5 from '../../assets/img/team-3.jpg';
import img6 from '../../assets/img/team-2.jpg';

const teamData = {
    teamData:[
        {
            id: 1,
            img: img1,
            title: "John Doe",
            text: "Senior Desinger"
        },
        {
            id: 2,
            img: img2,
            title: "John Doe",
            text: "Senior Desinger"
        },
        {
            id: 3,
            img: img3,
            title: "John Doe",
            text: "Senior Desinger"
        },
        {
            id: 4,
            img: img4,
            title: "John Doe",
            text: "Senior Desinger"
        },
        {
            id: 5,
            img: img5,
            title: "John Doe",
            text: "Senior Desinger"
        },
        {
            id: 6,
            img: img6,
            title: "John Doe",
            text: "Senior Desinger"
        },
    ]
}  
export default teamData
